import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0,0,0,0.5)"}
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Confirmação", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "×", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Tem certeza que deseja continuar?")
], -1)
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_12 = { class: "table-responsive p-0" }
const _hoisted_13 = { class: "table align-items-center mb-0" }
const _hoisted_14 = { class: "d-flex px-2 py-1" }
const _hoisted_15 = { class: "badge badge-sm bg-gradient-success" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = { class: "text-center text-xs font-weight-bold mb-0" }
const _hoisted_18 = {
  class: "align-middle text-center rota",
  style: {"display":"flex"}
}
const _hoisted_19 = { class: "stepper" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "icons-acao" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { style: {"font-size":"8px"} }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-flag" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDraggable = _resolveComponent("VueDraggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.showConfirmModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.showConfirmModal = false))
                }, _hoisted_7)
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.showConfirmModal = false))
                }, "Cancelar"),
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmAction && _ctx.confirmAction(...args)))
                }, "Confirmar")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("table", _hoisted_13, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rotas, (rota) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(rota.name) + " ", 1),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(rota.distance) + " Km", 1),
                          _hoisted_16,
                          _createElementVNode("span", _hoisted_17, "Serviços:" + _toDisplayString(rota.Pedidos.length), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          ($props.map)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: ($event: any) => ($setup.toggleUnicRoute(rota)),
                                class: "step icon",
                                style: _normalizeStyle({ backgroundColor: rota.color,  opacity: 1})
                              }, _hoisted_22, 12, _hoisted_20))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "step icon",
                            style: _normalizeStyle({ backgroundColor: rota.color,  opacity: 0.5})
                          }, _hoisted_24, 4),
                          _createVNode(_component_VueDraggable, {
                            ref_for: true,
                            ref: "el",
                            disabled: rota.confirmada,
                            modelValue: rota.Pedidos,
                            "onUpdate:modelValue": ($event: any) => ((rota.Pedidos) = $event),
                            animation: 150,
                            ghostClass: "ghost",
                            style: {"display":"flex"},
                            onStart: $setup.onStart,
                            onUpdate: $setup.onUpdate,
                            onEnd: (evt) => $setup.onEnd(evt, rota.id)
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rota.Pedidos, (pedido, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: pedido.ordem,
                                  class: _normalizeClass(['step', $setup.getClassByStatus(pedido.status_entrega),  pedido === 'Intervalo' ? 'interval' : ''])
                                }, [
                                  _createElementVNode("span", _hoisted_25, [
                                    _createElementVNode("i", {
                                      onClick: ($event: any) => ($setup.setCenterItem(pedido)),
                                      class: "fas fa-eye text-secondary",
                                      "aria-hidden": "true"
                                    }, null, 8, _hoisted_26)
                                  ]),
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(pedido.numero_pedido), 1)
                                ], 2))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "onStart", "onUpdate", "onEnd"]),
                          _createElementVNode("div", {
                            class: "step icon",
                            style: _normalizeStyle({ backgroundColor: rota.color,  opacity: 0.5})
                          }, _hoisted_29, 4)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 256))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}